import { NotifyHelper } from "../../../helpers/toast";
import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { eSaleSetRegisterActionTypeIds, ISaleSetRegisterActionTypes } from "../../action-types/dich-vu/ISaleSetRegisterActionTypes";
import { ISaleSetRegisterPageStateModel } from "../../page-state-model/dich-vu/ISaleSetRegisterPageState";

const initialState: ISaleSetRegisterPageStateModel = {
	status: ePageBaseStatus.is_not_initialization,
	saleset_registers: [],
	saleset_register_editing: undefined,
	saleset_register_selected_ids: [],
	saleset_register_types: [],
	saleset_register_types_by_hocsinh: [],
	detail_status: ePageBaseStatus.is_not_initialization,
	is_show_detail_modal: false
}

export const saleSetRegisterReducer = (state: ISaleSetRegisterPageStateModel = initialState, action: ISaleSetRegisterActionTypes): ISaleSetRegisterPageStateModel => {
	switch (action.type) {
		case eSaleSetRegisterActionTypeIds.LOAD_START:
			return {
				...state,
				status: ePageBaseStatus.is_loading
			}
		case eSaleSetRegisterActionTypeIds.LOAD_SUCCESS:
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				saleset_registers: action.payload
			}
		case eSaleSetRegisterActionTypeIds.LOAD_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				saleset_registers: []
			}
		case eSaleSetRegisterActionTypeIds.LOAD_REGISTER_TYPE_START:
			return {
				...state
			}
		case eSaleSetRegisterActionTypeIds.LOAD_REGISTER_TYPE_SUCCESS:
			return {
				...state,
				saleset_register_types: action.payload
			}
		case eSaleSetRegisterActionTypeIds.LOAD_REGISTER_TYPE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				saleset_register_types: []
			}
		case eSaleSetRegisterActionTypeIds.LOAD_REGISTER_TYPE_BY_HOCSINH_START:
			return {
				...state,
				detail_status: ePageBaseStatus.is_loading,
				saleset_register_types_by_hocsinh: []
			}
		case eSaleSetRegisterActionTypeIds.LOAD_REGISTER_TYPE_BY_HOCSINH_SUCCESS:
			return {
				...state,
				detail_status: ePageBaseStatus.is_completed,
				saleset_register_types_by_hocsinh: action.payload
			}
		case eSaleSetRegisterActionTypeIds.LOAD_REGISTER_TYPE_BY_HOCSINH_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				detail_status: ePageBaseStatus.is_completed,
				saleset_register_types_by_hocsinh: []
			}
		case eSaleSetRegisterActionTypeIds.SHOW_DETAIL:
			return {
				...state,
				is_show_detail_modal: true,
				saleset_register_editing: action.payload,
				saleset_register_types_by_hocsinh: []
			}
		case eSaleSetRegisterActionTypeIds.CLOSE_DETAIL:
			return {
				...state,
				is_show_detail_modal: false,
				saleset_register_editing: undefined,
				saleset_register_types_by_hocsinh: []
			}
		case eSaleSetRegisterActionTypeIds.CHANGE_SELECTED_IDS:
			return {
				...state,
				saleset_register_selected_ids: action.payload
			}
		case eSaleSetRegisterActionTypeIds.SAVE_START:
			return {
				...state,
				status: ePageBaseStatus.is_saving
			}
		case eSaleSetRegisterActionTypeIds.SAVE_SUCCESS:
			NotifyHelper.Success("Cập nhật thành công")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_detail_modal: false,
				saleset_register_editing: undefined,
				saleset_register_types_by_hocsinh: []
			}
		case eSaleSetRegisterActionTypeIds.SAVE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed
			}
		default:
			return state;
	}
}
